angular.module('NiacsProjectApp.lms-directives', [
  'NiacsProjectApp.services-project',
  'NiacsProjectApp.controllers',
  'NiacsProjectApp.lms-services',
  'NiacsProjectApp.lms-review'
])
.controller('EditCourseCtrl',['$scope','$uibModalInstance','theCourse',function($scope,$uibModalInstance,theCourse){
    if(theCourse.startDate) {
        theCourse.startDate = new Date(theCourse.startDate);
    }
    if(theCourse.endDate) {
        theCourse.endDate = new Date(theCourse.endDate);
    }
    $scope.course = theCourse;
    $scope.dismiss = $uibModalInstance.dismiss;
    $scope.ok = function() {
        if(theCourse.startDate) {
            theCourse.startDate = theCourse.startDate.getTime();
        }
        if(theCourse.endDate) {
            theCourse.endDate = theCourse.endDate.getTime();
        }
        $uibModalInstance.close($scope.course);
    };
}])
.directive('homeworkQuestions',[function(){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/homework-questions.html',
        scope: {
            questionSetTitle: '@',
            questionSet: '='
        },
        link: function($scope){
            $scope.addQ = function() {
                $scope.questionSet.qs.push({
                    id: niacs.guid(),
                    q: ''
                });
            };
            $scope.removeQ = function(q) {
                niacs.removeById($scope.questionSet.qs,q.id);
            };
        }
    };
}])
.directive('homeworkStats',[function(){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/homework-stats.html',
        scope: {
            homework: '=',
        }
    };
}])
.controller('EditHomeworkCtrl',['$scope','$uibModalInstance','theHomework',function($scope,$uibModalInstance,theHomework){
    function emptyHw(extend){
        return angular.extend({qs:[]},extend||{});
    }
    // build default question sets if they aren't already set.
    theHomework.long = theHomework.long||emptyHw();
    theHomework.qual = theHomework.qual||emptyHw({from:{v:1,label:'Low'},to:{v:5,label:'High'}});
    theHomework.short = theHomework.short||emptyHw();

    $scope.homework = theHomework;
    $scope.dismiss = $uibModalInstance.dismiss;
    $scope.ok = function() {
        $uibModalInstance.close($scope.homework);
    };
}])
.directive('courseListing',['$log','$http','$sce','$uibModal','DialogService','NiacsProject',function($log,$http,$sce,$uibModal,DialogService,NiacsProject){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/course-listing.html',
        scope: {
            course: '=',
            postUpdate: '&'
        },
        link: function($scope,$element,$attrs) {
            $scope.$watch('course',function(){
                if($scope.course) {
                    $scope.course.$description = $sce.trustAsHtml($scope.course.description);
                    NiacsProject.query({
                        'filter[field_related_course.id][value]': $scope.course.uuid,
                        'filter[field_related_course_offering][value]': $scope.course.version,
                        'fields[node--niacs_project]': 'drupal_internal__nid,uid',
                        'include': 'uid'
                    },function(listResponse) {
                        $scope.projectAuthors = listResponse.list.map(function(p) { return p.author; });
                        $log.debug('projectAuthors',$scope.projectAuthors);
                    });
                }
            });
            $scope.panelIcons = [{
                icon: 'pencil',
                tooltip: 'Edit',
                action: function(){
                    $uibModal.open({
                        templateUrl: 'partials/lms/edit-course-dialog.html',
                        controller: 'EditCourseCtrl',
                        windowClass: 'niacs-lms-course-dialog',
                        backdrop: 'static', // don't allow close by clicking outside dialog
                        size: 'lg',
                        keyboard: false, // ESC doesn't dismiss
                        resolve: {
                            theCourse: function() {
                                return angular.extend({},$scope.course);
                            }
                        }
                    }).result.then(function(edited){
                        angular.extend($scope.course,edited);
                        $scope.course.$update({id: $scope.course.id},$log.log,$log.error);
                    });
                }
            },{
                icon: 'file-plus',
                tooltip: 'New Course Offering',
                action: function(){
                    DialogService.safe({
                        message: 'Are you sure you want to create a new course offering for ' + $scope.course.title + '?',
                        warning: 'This cannot be undone.  By creating a new offering your current course will essentially be archived so that students can retain access to it as it was delivered.  You should only create a new course offering after delivery of a given course is complete.  If you choose to your new offering will be an exact duplicate of this course with its dates and enrollment reset.',
                        okText: 'Yes, create a new offering.',
                        cancelText: 'No, not yet.'
                    }).then(function(){
                        $http.post($scope.course._links.revise,{})
                             .then($scope.postUpdate,$log.error);
                    });

                }
            },{
                icon: 'clone',
                tooltip: 'Duplicate Course',
                action: function(){
                    DialogService.safe({
                        message: 'Are you sure you want to create a duplicate of ' + $scope.course.title + '?',
                        warning: 'A duplicate will get copies of all materials but changes to the copy and its materials will not affect the original',
                        okText: 'Yes, duplicate.',
                        cancelText: 'No.'
                    }).then(function(){
                        $http.post($scope.course._links.duplicate,{})
                             .then($scope.postUpdate,$log.error);
                    });

                }
            },{
                icon: 'times',
                tooltip: 'Delete This Course',
                action: function() {
                    DialogService.safe({
                        message: 'Are you sure you want to delete ' + $scope.course.title + '?',
                        warning: 'This cannot be undone.  Course materials will also be deleted.  If previous students created projects for this course they will be broken.',
                        okText: 'Yes, delete it.',
                        cancelText: 'No, keep it.',
                        conditions: [
                          $scope.course.revisions.length+' course offerings have been defined.'
                        ]
                    }).then(function(){
                        $log.debug('user confirmed removal of course',$scope.course);
                        $scope.course.$remove({id: $scope.course.id},$scope.postUpdate,$log.error);
                    });
                }
            }];

            $scope.editHomework = function(homework) {
                $uibModal.open({
                    templateUrl: 'partials/lms/edit-homework-dialog.html',
                    controller: 'EditHomeworkCtrl',
                    windowClass: 'niacs-lms-homework-dialog',
                    size: 'lg',
                    backdrop: 'static', // don't allow close by clicking outside dialog
                    keyboard: false, // ESC doesn't dismiss
                    resolve: {
                        theHomework: function() { return angular.copy(homework); }
                    }
                }).result.then(function(edited) {
                    $log.debug('original',homework);
                    $log.debug('edited',edited);
                    angular.extend(homework,edited);
                    $scope.course.$update({id: $scope.course.id},$log.log,$log.error);
                },$log.error);
            };

            // pulled from AngularJS input[email] source
            var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
            $scope.enrollment = {};
            $scope.getPotentialStudents = function($val) {
                return $http.get('/jsonapi/user/user',{
                    params: {
                        'filter[mail][value]': $val,
                        'filter[mail][operator]': 'CONTAINS',
                        'fields[user--user]': 'drupal_internal__uid,mail'
                    }
                }).then(function(response) {
                    if(!response.data.data.length && EMAIL_REGEXP.test($val)) {
                        return [{
                            uid: null,
                            mail: $val+' (preregister)',
                            preregister: $val
                        }];
                    }
                    return response.data.data.map(function(d) {
                        return {
                            uid: d.attributes.drupal_internal__uid,
                            mail: d.attributes.mail,
                            uuid: d.id
                        };
                    });
                });
            };
            $scope.haveStudentToPreregister = function() {
                return angular.isObject($scope.enrollment.studentToEnroll) &&
                       !$scope.enrollment.studentToEnroll.uid &&
                       $scope.enrollment.studentToEnroll.preregister &&
                       ($scope.course.preregistration||[]).indexOf($scope.enrollment.studentToEnroll.preregister.toLowerCase()) === -1;
            };
            $scope.haveStudentToEnroll = function() {
                return angular.isObject($scope.enrollment.studentToEnroll) &&
                        $scope.enrollment.studentToEnroll.uid &&
                       !($scope.course.enrollment||{})[$scope.enrollment.studentToEnroll.uid];
            };
            $scope.enrollStudent = function(student) {
                if(student.uid) {
                    if(!$scope.course.enrollment) {
                        $scope.course.enrollment = {};
                    }
                    $scope.course.enrollment[student.uid] = {
                        uid: student.uid,
                        mail: student.mail
                    };
                    $scope.course.$update({id: $scope.course.id},$log.log,$log.error);
                } else if (student.preregister) {
                    if(!$scope.course.preregistration) {
                        $scope.course.preregistration = [];
                    }
                    $scope.course.preregistration.push(student.preregister.toLowerCase());
                    $scope.course.$update({id: $scope.course.id},$log.log,$log.error);
                }
            };
            $scope.disenrollStudent = function(student) {
                delete $scope.course.enrollment[student.uid];
                $scope.course.$update({id: $scope.course.id},$log.log,$log.error);
            };
            $scope.removePreregistration = function(email) {
                var idx = ($scope.course.preregistration||[]).indexOf(email);
                if(idx !== -1) {
                    $scope.course.preregistration.splice(idx,1);
                    $scope.course.$update({id: $scope.course.id},$log.log,$log.error);
                }
            };
            $scope.reviewProjects = function(offering){
                $uibModal.open({
                    templateUrl: 'partials/lms/review-course-projects-dialog.html',
                    controller: 'ReviewCourseProjectsCtrl',
                    windowClass: 'niacs-lms-projects-review-dialog',
                    size: 'huge',
                    backdrop: 'static', // don't allow close by clicking outside dialog
                    keyboard: false, // ESC doesn't dismiss
                    resolve: {
                        theOffering: function() { return offering; }
                    }
                });
            };
            $scope.reviewHomework = function(offering){
                $uibModal.open({
                    templateUrl: 'partials/lms/review-course-homework-dialog.html',
                    controller: 'ReviewCourseHomeworkCtrl',
                    windowClass: 'niacs-lms-homework-review-dialog',
                    size: 'huge',
                    backdrop: 'static', // don't allow close by clicking outside dialog
                    keyboard: false, // ESC doesn't dismiss
                    resolve: {
                        theOffering: function() { return offering; }
                    }
                });
            };
        }
    };
}])
.directive('courseList', ['$log','$uibModal','Course',function($log,$uibModal,Course){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/course-list.html',
        link: function($scope,$element,$attrs) {
            $scope.reload = function() {
                $scope.courses = [];
                $log.debug('reloading course list');
                Course.query(function(courses) {
                    $log.debug('courses',courses);
                    $scope.courses = courses.list;
                });
            };
            $scope.reload(); // get things going
            $scope.panelIcons = [{
                icon: 'sync-alt',
                tooltip: 'Refresh',
                action: $scope.reload
            },{
                icon: 'plus',
                tooltip: 'Create New Course',
                action: function(){
                    $uibModal.open({
                        templateUrl: 'partials/lms/edit-course-dialog.html',
                        controller: 'EditCourseCtrl',
                        windowClass: 'niacs-lms-course-dialog',
                        backdrop: 'static', // don't allow close by clicking outside dialog
                        keyboard: false, // ESC doesn't dismiss
                        resolve: {
                            theCourse: function() { return new Course({}); }
                        }
                    }).result.then(function(course){
                        // pre-define homework
                        course.homework = {
                            'Step 1': [{title: 'Homework 1'}],
                            'Step 2': [{title: 'Homework 2'}],
                            'Step 3': [{title: 'Homework 3'}],
                            'Step 4': [{title: 'Homework 4'}],
                            'Step 5': [{title: 'Homework 5'},{title: 'Homework 6'}],
                        };
                        // generate an id for each
                        Object.keys(course.homework).forEach(function(key){
                            course.homework[key].forEach(function(hw){
                                hw.id = niacs.guid();
                            });
                        });
                        course.$save($scope.reload,$log.error);
                    },$log.error);
                }
            }];
        }
    };
}])
.controller('LmsProjectExport',['$log','$scope','$routeParams','CourseProject','ProjectService',
    function($log,$scope,$routeParams,CourseProject,ProjectService){
    $log.debug('$routeParams',$routeParams);
    CourseProject.query({
        'filter[drupal_internal__nid][value]': $routeParams.id,
        'filter[field_related_course.drupal_internal__nid][value]': $routeParams.course,
        'filter[field_related_course_offering][value]': $routeParams.offering
    },function(projects) {
        $log.debug('projects',projects);
        if(projects && projects.list && projects.list.length) {
            var project = projects.list.reduce(function(p,c){
                    if(!p && c.id == $routeParams.id) {
                        p = c;
                    }
                    return p;
                },undefined);
            if(project) {
                ProjectService.expand(project,function(p) {
                    $scope.project = p;
                });
            }
        }
    });
}]);